angular.module('impactx.stockwithdrawal').controller('StockWithdrawalCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToolbarService',
    'OutsourcedCommentSaveService',
    'BackService',
    'ToastService',
    'TranslationService',
    StockWithdrawalController
]);

function StockWithdrawalController($scope, dataGen, $routeParams, ToolbarService, OutsourcedCommentSaveService, BackService, ToastService, TranslationService) {
    var self = this;
    self.dniInfoId = $routeParams.dniInfoId || 0;
    self.stoliId = $routeParams.stoliId || 0;

    dataGen.getData($scope, {
        dniInfoId: self.dniInfoId,
        stoliId: self.stoliId
    }, '/stockwithdrawal/view').then(function () {
        $scope.data.creationDate.dateValue = new Date($scope.data.creationDate.dateValue);
        defineButtons();
    });

    self.createNewDNIInfo = function () {
        var extractedComments = OutsourcedCommentSaveService.extractComments($scope.data);

        return dataGen.postAsForm($scope, {dialogData: $scope.data}, '/stockwithdrawal/save').then(function (commentData) {
            if (commentData && commentData.data) {
                return OutsourcedCommentSaveService.saveComments(commentData.data, extractedComments);
            }
        }).finally(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            BackService.back();
        });
    };

    function defineButtons() {
        var buttonDefinition = [{
            label: $scope.trns.createNewDNIInfo,
            action: self.createNewDNIInfo,
            type: 'validation',
            condition: canCreateNew,
            params: {
                form: $scope.dialogData
            }
        }];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canCreateNew() {
        return $scope.data.canCreateNewDNIInfo;
    }
}